import {
  base_colorAlert,
  base_colorHighlight,
  text_colorTextPrimary,
} from 'ext-ui/style/colors'
import {
  font_family_weight_regular,
  font_sm,
  fontBold,
  fontH2,
  fontRegular,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.SignupSsoForm {
    form {
      display: flex;
      flex-direction: column;
    }

    .heading {
      ${fontH2};
      color: ${text_colorTextPrimary};
      margin-bottom: 30px;
    }

    .orgName {
      ${fontH2};
      color: ${base_colorHighlight};
    }

    .description {
      ${fontRegular};
      color: ${text_colorTextPrimary};
      margin-bottom: 40px;
    }

    .inviterNameAndEmail {
      ${fontBold};
      color: ${text_colorTextPrimary};
    }

    .lockedIcon {
      opacity: 50%;
      transform: scale(calc(18 / 24));
      transform-origin: center;
      flex-shrink: 0;
    }

    .errorText {
      align-self: center;
      color: ${base_colorAlert};
      margin-top: 20px;
    }

    .submitButton {
      margin-top: 40px;
    }

    .footer {
      align-self: center;
      margin-top: 20px;
      ${font_sm};
      font-family: ${font_family_weight_regular};
      color: ${text_colorTextPrimary};
    }
  }
`
